//直播详情接口
import states    from '../state/live';
import mutations from '../mutations/live';
import actions   from '../actions/live';
import getters   from '../getters/live';

export default {
    namespaced: true,
    states,
    mutations,
    actions,
    getters
};
